import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import PinPage from '../../components/PinPage/PinPage';

import { confirmPinApi } from '../../services/authApi/forgotPinApi';
import { toastNotify } from '../../utils/toastNotify';

const ConfirmNewPIN = () => {
  const [confirmPin, setConfirmPin] = useState(undefined);
  const [loading, setLoading] = useState(false);
  let navigate = useNavigate();

  const handleConfirmPin = async () => {
    let pin = localStorage.getItem('pin');
    setLoading(true);
    if (pin === confirmPin) {
      let formData = {
        newPin: confirmPin,
      };
      try {
        const userData = await confirmPinApi(formData);
        if (!userData.isError) {
          navigate('/forgot-password/allset');
          localStorage.removeItem('pin');
        } else {
          setConfirmPin('');
          toastNotify('error', userData?.message);
        }
      } catch (error) {
        setConfirmPin('');
        const { response } = error;
        if (
          response?.data?.message === 'New pin should be different from old pin.' ||
          response?.data?.message === 'Reuse of previous PIN not allowed. Please choose a new one.'
        ) {
          localStorage.removeItem('pin');
          navigate('/forgot-pin/create-new-pin', { replace: true });
        }
        toastNotify('error', response?.data?.message);
      } finally {
        setLoading(false);
      }
    } else {
      toastNotify('error', 'PIN does not match');
      setConfirmPin('');
      setLoading(false);
      localStorage.removeItem('pin');
      navigate('/forgot-pin/create-new-pin', { replace: true });
    }
  };
  return (
    <div className='auth auth--no-info-mobile'>
      <PinPage
        pin={confirmPin}
        buttonName={'Submit'}
        authInfoTitle={'Welcome back'}
        authInfoDescription={'Enter your credentials to access your Realbricks account.'}
        authFormTitle={'Re-enter your PIN'}
        authFormDescription={'Enter the 4-digit PIN you previously entered to ensure it is a match.'}
        setPin={(value) => setConfirmPin(value)}
        handleSubmit={handleConfirmPin}
        loading={loading}
        backButton
        backButtonRedirection={'forgot-pin/create-new-pin'}
      />
    </div>
  );
};

export default ConfirmNewPIN;
